import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import pdf from "../../Assets/resume.pdf";

function Resume() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={8} className="resume-left">
            <h3 className="resume-title">Experience</h3>

            <Resumecontent
              title="Inteliyo - Lead Frontend Developer"
              date="November 2021 - present"
              content={[
                "Working on a Healthcare project and leading frontend team.",
                "Implemented AWS kinesis for VideoCall Streaming and integrating Graphql to React Application.",
                "Developed more than 20 pages with authentication and proper data management.",
                "Tech Stack used: ReactJS, mobiscroll UI, graphQl, AWS Services, python",
              ]}
            />

            <Resumecontent
              title="JP Morgan Chase & Co. - Software Developer Intern"
              date="May 2022 - July 2022"
              content={[
                "Worked with their portal team where i helped in building simple flexible UI for multiple portal login pages",
              ]}
            />
            <Resumecontent
              title="Mapout - React Developer"
              date="August 2021 - November 2021"
              content={[
                "Worked on creating a platform having multiple functionalities like career test, building a job portal as well as mentor forms.",
                "<a href='https://www.mapout.com/</a>",
              ]}
            />
          </Col>
          <Col md={4} className="resume-right">
            <h3 className="resume-title">Skills</h3>

            <Resumecontent
              title="Web Technologies"
              content={[
                "ReactJs",
                "NextJS",
                "Typescript",
                "Javascript",
                "NodeJS",
                "Ethers.JS(basics)",
              ]}
            />
            <Resumecontent
              title="UI Libraries"
              content={[
                "Material UI",
                "Tailwind CSS",
                "Bootstrap",
                "Mobiscroll",
                "SASS",
              ]}
            />
            <Resumecontent
              title="Programming Languages"
              date=""
              content={["C++", "Java"]}
            />
            <Resumecontent
              title="Others"
              date=""
              content={["Git", "React Native"]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}></Row>
      </Container>
    </Container>
  );
}

export default Resume;
